export const DBConfig = {
  name: 'MyPaveDB',
  version: 1,
  objectStoresMeta: [
    {
      store: 'pwaPhotos',
      storeConfig: { keyPath: 'sessionkeyid', unique: true },
      storeSchema: [
        {
          name: 'sessionkeyid',
          keypath: 'sessionkeyid',
          options: { unique: true },
        },
        {
          name: 'sessionKey',
          keypath: 'sessionKey',
          options: { unique: false },
        },
        {
          name: 'countScreen',
          keypath: 'countScreen',
          options: { unique: false },
        },
        {
          name: 'photoCode',
          keypath: 'photoCode',
          options: { unique: false },
        },
        {
          name: 'base64',
          keypath: 'base64',
          options: { unique: false },
        },
      ],
    },
    {
      store: 'pwaSetting',
      storeConfig: { keyPath: 'id', autoIncrement: true },
      storeSchema: [
        {
          name: 'sessionKey',
          keypath: 'sessionKey',
          options: { unique: false },
        },
        {
          name: '_disclosures',
          keypath: '_disclosures',
          options: { unique: false },
        },
        {
          name: '_announcements',
          keypath: '_announcements',
          options: { unique: false },
        },
        {
          name: '_theme',
          keypath: '_theme',
          options: { unique: false },
        },
      ],
    },
  ],
};
